export var NcodePdfScaleMode;
(function (NcodePdfScaleMode) {
    NcodePdfScaleMode[NcodePdfScaleMode["IMAGE_SIZE_UP_TO_PAGE"] = 0] = "IMAGE_SIZE_UP_TO_PAGE";
    NcodePdfScaleMode[NcodePdfScaleMode["PAGE_SIZE_DOWN_TO_IMAGE"] = 1] = "PAGE_SIZE_DOWN_TO_IMAGE";
    NcodePdfScaleMode[NcodePdfScaleMode["NO_SCALE"] = 2] = "NO_SCALE";
    NcodePdfScaleMode[NcodePdfScaleMode["IMAGE_SIZE_UP_TO_PAGE_PADDING"] = 3] = "IMAGE_SIZE_UP_TO_PAGE_PADDING";
})(NcodePdfScaleMode || (NcodePdfScaleMode = {}));
export var ColorConvertMethod;
(function (ColorConvertMethod) {
    ColorConvertMethod[ColorConvertMethod["BLUEPRINT"] = 0] = "BLUEPRINT";
    ColorConvertMethod[ColorConvertMethod["ANDROID_STYLE"] = 1] = "ANDROID_STYLE";
    ColorConvertMethod[ColorConvertMethod["IPHONE_STYLE"] = 2] = "IPHONE_STYLE";
})(ColorConvertMethod || (ColorConvertMethod = {}));
//# sourceMappingURL=PrintEnums.js.map